import { useQuery } from '@tanstack/react-query';
import { CLASSIFICATION_COUNTRY_KEY } from '../../utils/constants/queryKeys';
import { getImmigrationStatusClassification } from '../services/fn-api/ImmigrationStatus';

export const useGetImmigrationStatusClassification = (countryCode: string, activeClassification: boolean) => {
  return useQuery({
    queryKey: [CLASSIFICATION_COUNTRY_KEY],
    queryFn: () => getImmigrationStatusClassification(countryCode, activeClassification),
    enabled: !!countryCode,
  });
};
